const TIANQI = {
  company: "陈永艳",
  icp: "京ICP备2024080273号-1",
};
const XMILES = {
  company: "广州小迈网络科技有限公司",
  icp: "粤ICP备15016492号-12",
};
const GMILES = {
  company: "广州聚迈软件科技有限公司",
  icp: "粤ICP备16021104号-3",
  companyShort: "聚迈科技",
};
const MICAI = {
  company: "广州迈远信息科技有限公司",
  icp: "粤ICP备17068958号-3",
};
const MAIZHI = {
  company: "广州迈致科技有限公司",
  icp: "粤ICP备20058990号-1",
};
const SHIQIU = {
  company: "广州时秋网络科技有限公司",
  icp: "粤ICP备20056318号-3",
};
const LIANGTUI = {
  company: "广州亮推网络科技有限公司",
};
const JIETUI = {
  company: "广州杰推网络科技有限公司",
};
const RUIFENG = {
  company: "广州睿丰网络科技有限公司",
};
const YONGTUI = {
  company: "广州勇推网络科技有限公司",
};
const ZUOFENG = {
  company: "广州卓丰网络科技有限公司",
};
const JIATUI = {
  company: "湖州嘉推信息技术工作室",
};

const PRDLIST = [
  {
    prdid: 211001,
    name: "恋小知",
    ...TIANQI,
  },
  {
    prdid: 22000,
    name: "成语升官传",
    ...MICAI,
  },
  {
    prdid: 22001,
    name: "成语状元榜",
    ...MICAI,
  },
  {
    prdid: 22002,
    name: "成语小富翁",
    ...MICAI,
  },
  {
    prdid: 22003,
    name: "答多多",
    ...XMILES,
  },
  {
    prdid: 22004,
    name: "官人猜成语",
    ...MICAI,
  },
  {
    prdid: 22005,
    name: "状元猜成语",
    ...XMILES,
  },
  {
    prdid: 22006,
    name: "成语最强答人",
    ...XMILES,
  },
  {
    prdid: 22007,
    name: "开心猜成语",
    ...XMILES,
  },
  {
    prdid: 22008,
    name: "爱上猜成语",
    ...MICAI,
  },
  {
    prdid: 22009,
    name: "天天猜成语",
    ...MAIZHI,
  },
  {
    prdid: 22010,
    name: "成语多多",
    ...SHIQIU,
  },
  {
    prdid: 24000,
    name: "极品小老板",
    ...XMILES,
  },
  {
    prdid: 210101,
    name: "今晚迎财神",
    ...GMILES,
  },
  {
    prdid: 40000,
    name: "哆米应用",
    ...GMILES,
  },
];

//内购相关协议产品信息
export const IAP_PRDINFO_MAP = {
  1010101: { prdId: "1010101", prdName: "皮皮动态壁纸", ...ZUOFENG },
  1010201: { prdId: "1010201", prdName: "多多动态壁纸", ...JIATUI },
  1010401: { prdId: "1010401", prdName: "大众动态壁纸", ...SHIQIU },
  1010501: { prdId: "1010501", prdName: "皮皮壁纸", ...JIETUI },
  1010601: { prdId: "1010601", prdName: "皮皮桌面壁纸", ...MICAI },
};

//sdk隐私协议产品信息
export const SDK_INFO_MAP = {
  ZF: { sdkName: "卓丰SDK", ...ZUOFENG },
  JT: { sdkName: "杰推SDK", ...JIETUI },
  RF: { sdkName: "北极星开发者SDK", ...ZUOFENG },
  YT: { sdkName: "勇推SDK", ...YONGTUI },
  MJ: { sdkName: "迈竞SDK", company: "广州拓跋网络科技有限公司" },
  YG: { sdkName: "摇光SDK", company: "广州岩中花网络科技有限公司" },
};

export const NOT_LOGOUT_PRDIDS = ["190111"];

export const PUSH_EXPLAIN_PRDIDS = ["128003"];

export default PRDLIST;
